import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
export const firebaseConfig = {
  apiKey: "AIzaSyBj_jIXjrrptNX4olgb--Q6lBj-tDaTgZQ",
  authDomain: "react-notes-88862.firebaseapp.com",
  projectId: "react-notes-88862",
  databaseURL: "https://react-notes-88862-default-rtdb.firebaseio.com",
  storageBucket: "react-notes-88862.appspot.com",
  messagingSenderId: "695898646866",
  appId: "1:695898646866:web:81c2342e9cd2f7d96fb28b",
  measurementId: "G-5B1TL5JHMR",
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
